import { useState, useEffect, useRef } from 'react'
import { X } from 'lucide-react'
import organizadoresService from '../../services/organizadoresService'
import fichaLeiloeiroService from '../../services/fichaLeiloeiroService'
import { useOrganizador } from '../../contexts/OrganizadorContext'
import './ficha-leiloeiro.css'

export default function FichaLeiloeiroIndividual({ lote, onClose }) {
  const { organizadorAtivo } = useOrganizador()
  const [organizador, setOrganizador] = useState(null)
  const [config, setConfig] = useState({
    mostrar_vendedor: true,
    mostrar_cidade: true,
    mostrar_ordem: true,
    mostrar_lote: true,
    mostrar_qtd: true,
    mostrar_tipo: true,
    mostrar_raca: true,
    mostrar_curral: true,
    mostrar_sexo: true,
    mostrar_idade: true,
    mostrar_peso: true,
    mostrar_observacoes: true,
    fichas_por_folha: 1,
    mostrar_logo: true
  })
  const printRef = useRef()

  useEffect(() => {
    if (organizadorAtivo?.id) {
      loadConfig()
    }
  }, [organizadorAtivo])

  const loadConfig = async () => {
    try {
      const [orgResponse, configResponse] = await Promise.all([
        organizadoresService.getById(organizadorAtivo.id),
        fichaLeiloeiroService.getConfig(organizadorAtivo.id)
      ])
      setOrganizador(orgResponse)
      setConfig(configResponse)
    } catch (error) {
      console.error('Erro ao carregar configurações:', error)
    }
  }

  const handlePrint = () => {
    if (printRef.current) {
      const printWindow = window.open('', '_blank', 'width=800,height=600')
      printWindow.document.write(`
        <html>
          <head>
            <title>Ficha do Leiloeiro - Lote ${lote.numero_lote}</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                margin: 0; 
                padding: 15px;
                background: white;
              }
              
              .ficha-lote {
                width: 100%;
                height: 50vh;
                margin: 0 auto;
                border: 2px solid #000;
                background: white;
                page-break-inside: avoid;
              }
              
              .ficha-logos {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 12px;
                border-bottom: 1px solid #ccc;
                min-height: 60px;
                background: #f8f9fa;
                position: relative;
              }
              
              .logo-cliente {
                max-height: 50px;
                max-width: 120px;
                object-fit: contain;
              }
              
              .logo-rematei {
                max-height: 40px;
                max-width: 80px;
                object-fit: contain;
              }
              
              .lote-destaque {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
              }
              
              .lote-destaque-label {
                font-size: 12px;
                font-weight: normal;
                color: #666;
                margin-bottom: 2px;
                text-transform: uppercase;
              }
              
              .lote-destaque-numero {
                font-size: 32px;
                font-weight: bold;
                color: #000;
                line-height: 1;
              }
              
              .ficha-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px solid #000;
                padding: 8px 12px;
                background: #f8f9fa;
              }
              
              .vendedor-section {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 4px;
              }
              
              .vendedor-info {
                font-weight: bold;
                font-size: 16px;
                text-transform: uppercase;
                color: #000;
              }
              
              .cidade-info {
                font-weight: normal;
                font-size: 14px;
                text-transform: uppercase;
                color: #666;
                padding-left: 10px;
                border-left: 3px solid #007bff;
              }
              
              .header-right {
                display: flex;
                align-items: center;
                gap: 15px;
              }
              
              .cidade {
                font-weight: bold;
                font-size: 12px;
                text-align: center;
                min-width: 80px;
              }
              
              .ordem {
                font-weight: bold;
                font-size: 10px;
                text-align: center;
                min-width: 40px;
                border-left: 1px solid #000;
                padding-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              
              .ordem-label {
                font-size: 8px;
                color: #666;
                margin-bottom: 2px;
              }
              
              .ficha-dados {
                display: grid;
                border-bottom: 2px solid #000;
              }
              
              .campo {
                border-right: 1px solid #000;
                text-align: center;
                padding: 8px 4px;
              }
              
              .campo:last-child {
                border-right: none;
              }
              
              .campo .label {
                font-size: 12px;
                font-weight: bold;
                color: #666;
                margin-bottom: 4px;
                text-transform: uppercase;
              }
              
              .campo .valor {
                font-size: 14px;
                font-weight: bold;
                color: #000;
                text-transform: uppercase;
                min-height: 18px;
                white-space: nowrap;
              }
              
              .ficha-observacoes {
                padding: 8px;
                min-height: 60px;
                position: relative;
                border-bottom: 1px solid #ccc;
              }
              
              .obs-label {
                font-size: 10px;
                font-weight: bold;
                color: #666;
                text-transform: uppercase;
                margin-bottom: 8px;
              }
              
              .obs-content {
                font-size: 11px;
                color: #000;
                line-height: 1.4;
                text-transform: uppercase;
              }
              
              @page { 
                size: A4 portrait; 
                margin: 0.5cm;
              }
            </style>
          </head>
          <body>
            ${printRef.current.innerHTML}
          </body>
        </html>
      `)
      
      printWindow.document.close()
      
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus()
          printWindow.print()
          
          const forceClose = () => {
            try {
              printWindow.close()
            } catch (e) {
              console.log('Janela já fechada')
            }
          }
          
          setTimeout(forceClose, 500)
          setTimeout(forceClose, 1000)
          setTimeout(forceClose, 2000)
          
          printWindow.addEventListener('afterprint', forceClose)
          printWindow.addEventListener('beforeunload', forceClose)
        }, 500)
      }
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold">Ficha do Leiloeiro - Lote {lote.numero_lote}</h2>
          <div className="flex gap-2">
            <button
              onClick={handlePrint}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Imprimir
            </button>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>
          </div>
        </div>
        
        <div className="p-6">
          <div ref={printRef}>
            <div className="ficha-lote">
              {/* Logos da ficha */}
              {config.mostrar_logo && (
                <div className="ficha-logos">
                  <div>
                    {organizador?.logo_url && (
                      <img 
                        src={organizador.logo_url} 
                        alt="Logo Cliente" 
                        className="logo-cliente"
                      />
                    )}
                  </div>
                  <div className="lote-destaque">
                    <div className="lote-destaque-label">LOTE</div>
                    <div className="lote-destaque-numero">{String(lote.numero_lote || lote.numero || '')}</div>
                  </div>
                  <div>
                    <img 
                      src="/assets/rematei.png" 
                      alt="Rematei" 
                      className="logo-rematei"
                    />
                  </div>
                </div>
              )}
              
              {/* Cabeçalho da ficha */}
              <div className="ficha-header">
                <div className="vendedor-section">
                  {config.mostrar_vendedor && (
                    <div className="vendedor-info">
                      {(lote.vendedor?.nome || lote.vendedor_nome)?.toUpperCase() || 'VENDEDOR NÃO INFORMADO'}
                      {(lote.fazenda?.nome || lote.fazenda) && ` - ${String(lote.fazenda?.nome || lote.fazenda).toUpperCase()}`}
                    </div>
                  )}
                  {(lote.vendedor?.cidade || lote.vendedor?.estado) && (
                    <div className="cidade-info">
                      {(lote.vendedor?.cidade || '').toUpperCase()}
                      {(lote.vendedor?.estado || lote.vendedor?.uf) && ` - ${(lote.vendedor?.estado || lote.vendedor?.uf).toUpperCase()}`}
                    </div>
                  )}
                </div>
                <div className="header-right">
                  {config.mostrar_cidade && (
                    <div className="cidade">{lote.cidade?.toUpperCase() || ''}</div>
                  )}
                  {config.mostrar_ordem && (
                    <div className="ordem">
                      <div className="ordem-label">O.D</div>
                      <div>{lote.posicao || lote.ordem || 1}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Dados do lote */}
              <div className="ficha-dados" style={{
                gridTemplateColumns: `repeat(${[
                  true, // QTD sempre visível
                  config.mostrar_tipo,
                  config.mostrar_raca,
                  config.mostrar_curral,
                  config.mostrar_sexo,
                  config.mostrar_idade,
                  config.mostrar_peso
                ].filter(Boolean).length}, 1fr)`
              }}>
                {/* QTD sempre visível */}
                <div className="campo">
                  <div className="label">QTD</div>
                  <div className="valor">{lote.qtd || lote.quantidade || 1}</div>
                </div>
                {config.mostrar_tipo && (
                  <div className="campo">
                    <div className="label">TIPO</div>
                    <div className="valor">{lote.tipo_animal?.nome?.toUpperCase() || ''}</div>
                  </div>
                )}
                {config.mostrar_raca && (
                  <div className="campo">
                    <div className="label">RAÇA</div>
                    <div className="valor">{lote.raca?.nome?.toUpperCase() || ''}</div>
                  </div>
                )}
                {config.mostrar_curral && (
                  <div className="campo">
                    <div className="label">CURRAL</div>
                    <div className="valor">{lote.curral || ''}</div>
                  </div>
                )}
                {config.mostrar_sexo && (
                  <div className="campo">
                    <div className="label">SEXO</div>
                    <div className="valor">{lote.sexo?.toUpperCase() || ''}</div>
                  </div>
                )}
                {config.mostrar_idade && (
                  <div className="campo">
                    <div className="label">IDADE</div>
                    <div className="valor">{lote.idade?.nome?.replace('meses', 'M').replace('anos', 'A') || ''}</div>
                  </div>
                )}
                {config.mostrar_peso && (
                  <div className="campo">
                    <div className="label">PESO</div>
                    <div className="valor">
                      {(() => {
                        const peso = lote.peso_medio || lote.peso
                        if (!peso) return ''
                        const pesoNum = parseFloat(peso)
                        if (pesoNum > 100) {
                          const pesoAbrev = pesoNum.toString().length > 4 ? pesoNum.toFixed(1) : peso
                          const arrobas = (pesoNum / 30).toFixed(1)
                          return `${pesoAbrev} - ${arrobas}@`
                        }
                        return `${peso}kg`
                      })()}
                    </div>
                  </div>
                )}
              </div>

              {/* Observações */}
              {config.mostrar_observacoes && (
                <div className="ficha-observacoes">
                  <div className="obs-label">OBSERVAÇÕES</div>
                  <div className="obs-content">
                    {(() => {
                      let obs = lote.observacoes || '';
                      const criasF = lote.qtd_crias_femeas || 0;
                      const criasM = lote.qtd_crias_machos || 0;
                      if (criasF > 0 || criasM > 0) {
                        const partes = [];
                        if (criasF > 0) partes.push(`F:${criasF}`);
                        if (criasM > 0) partes.push(`M:${criasM}`);
                        const criasTxt = `Crias: ${partes.join(' ')}`;
                        obs = obs ? `${criasTxt} | ${obs}` : criasTxt;
                      }
                      return obs;
                    })()}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}